export default "__VITE_ASSET__MoMlWNaY__"